// Match sortScores in public/disruptor/leaderboard/static/js without mutating
// customisation data. Keep source indices for stable input keys and edits.
export const sortLeaderboardEntries = (entries, settings) => {
    const field = settings.scoreType === 'time' && settings.type !== 'spam' ? 'time' : 'score';
    const ascending = settings.ascending && settings.type !== 'spam';
    const scored = [];
    const unscored = [];

    entries.forEach((entry, sourceIndex) => {
        const value = entry[field];
        const row = { entry, sourceIndex };
        if (value && value != 0 && value !== undefined) {
            scored.push(row);
        } else {
            unscored.push(row);
        }
    });

    scored.sort((a, b) => ascending
        ? a.entry[field] - b.entry[field] || a.entry[field] != 0
        : b.entry[field] - a.entry[field] || b.entry[field] != 0);
    return scored.concat(unscored);
};
